import { Divider } from '@delmonicos/shared-design-system-react/src/components/divider/divider';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { useGetUsersPaginatedFormValidation } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/users/models/inputs/get-users-paginated.form-validation';
import { GetUsersPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/users/models/inputs/get-users-paginated.model';
import { Controller, useFormContext } from 'react-hook-form';

import { CustomerFilterController } from '@app/feature/customer/customer-filter/customer-filter.controller';
import { RoleFilterController } from '@app/feature/role/role-filter/role-filter.controller';

const UserListFilterFormStep1CustomerIdFragment = (): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  // const { t } = useTranslation();
  const { control } = useFormContext<GetUsersPaginatedModel>();
  const { customerId } = useGetUsersPaginatedFormValidation();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <>
      <Controller
        name="customerId"
        control={control}
        rules={customerId}
        render={({ field /* , fieldState: { error } */ }) => {
          const values = [];

          if (Array.isArray(field.value)) {
            values.push(...field.value);
          } else if (field.value) {
            values.push(field.value);
          }

          return (
            <CustomerFilterController
              selectedItemIds={values}
              onChange={(value) => field.onChange(value)}
            />
          );
        }}
      />
      <Divider />
    </>
  );
};

const UserListFilterFormStep1RoleIdFragment = (): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  // const { t } = useTranslation();
  const { control } = useFormContext<GetUsersPaginatedModel>();
  const { roleId } = useGetUsersPaginatedFormValidation();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Controller
      name="roleId"
      control={control}
      rules={roleId}
      render={({ field /* , fieldState: { error } */ }) => {
        const values = [];

        if (Array.isArray(field.value)) {
          values.push(...field.value);
        } else if (field.value) {
          values.push(field.value);
        }

        return (
          <RoleFilterController
            selectedItemIds={values}
            onChange={(value) => field.onChange(value)}
          />
        );
      }}
    />
  );
};

export const UserListFilterFormStep1Controller = (): React.JSX.Element => {
  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Stack
      direction="row"
      justifyContent="stretch"
      alignItems="stretch"
      flex={1}
      gap={GapEnum.M}>
      <Stack direction="column" flex={1} alignItems="stretch" gap={GapEnum.M}>
        <UserListFilterFormStep1CustomerIdFragment />
        <UserListFilterFormStep1RoleIdFragment />
      </Stack>
    </Stack>
  );
};
